"use client";

import { redirect } from "next/navigation";
import useTNStore from "@/stores/TNStore";

export default function Home() {
    const { tn } = useTNStore();
    if (tn !== null && tn !== "") {
        redirect(`/voice-settings/${tn}/forwarding`);
    } else {
        return "No Number is selected.";
    }
}
